import { useContext, useEffect } from 'react';

import FeatureFlagService from 'Services/FeatureFlags';
import { ConfigContext } from 'Contexts/Config';
import store from 'Src/store';

const useFeatureFlagsProvider = () => {
  const {
    actions: featureActions,
    state: { providersReady, error },
  } = useContext(ConfigContext);
  const { isReady } = providersReady ?? {};
  const { hasErrors, errors } = error ?? {};
  const autoRefresh = () => {
    if (!FeatureFlagService.isReady) featureActions.refreshFeatureFlags();
  };

  useEffect(() => {
    autoRefresh();
    return store.subscribe(autoRefresh);
  }, []);

  return {
    errors,
    hasErrors,
    isReady,
  };
};

export default useFeatureFlagsProvider;
